import React from "react";
import { LOGO_MARK } from "../../config/assets";
import BrandName from "./BrandName";

// Full-screen branded loader — the WOW boot / network-switch / tx-wait screen.
export default function Loader({ text = "Loading", brand = true }) {
  return (
    <div className="loader-overlay">
      <div className="loader-stage">
        <span className="ring r1" />
        <span className="ring r2" />
        <span className="ring r3" />
        <img src={LOGO_MARK} alt="Nexaura" />
      </div>
      {brand && <div className="loader-brand"><BrandName /></div>}
      <div className="loader-bar">
        <i />
      </div>
      <div className="loader-text">{text}</div>
    </div>
  );
}
